import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box } from '@mui/material';
import { FileGridItem } from './FileGridItem';
import { FileListStateShape } from '../hooks/useFileListState';

export const FileGridLayout = ({ fileListState, drawer = false }) => (
  <Box sx={{ width: '100%', overflowX: 'hidden' }}>
    <Grid
      container
      spacing={2}
      mt={2}
      sx={{
        width: '100%',
        flexWrap: 'wrap',
      }}
    >
      {fileListState.visibleFiles.map((file) => (
        <FileGridItem
          key={file.id}
          file={file}
          fileListState={fileListState}
          drawer={drawer}
        />
      ))}
    </Grid>
  </Box>
);

FileGridLayout.propTypes = {
  fileListState: FileListStateShape.isRequired,
  drawer: PropTypes.bool,
};

FileGridLayout.defaultProps = {
  drawer: false,
};
